import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { CategoryRepository } from "@/repositories/category";
import { CategoryFormData } from "@/schemas/category-form.schema";

export const useCreateCategory = () => {
  const categoriesRepository = useRef(new CategoryRepository());

  return useMutation({
    mutationFn: (data: CategoryFormData) =>
      categoriesRepository.current.add(data),
  });
};
